import { createContext } from 'react';

const LIContext = createContext();

export default LIContext;
